import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import CommonDropdown from "../common/common_dropDown";
import SearchableDropdown from "../common/commonDropDown";
import { MoveLeft } from "lucide-react";
import AsyncSelect from "react-select/async";
import { getDriverAutoCompleteApi } from "./trips-api";

const DriverAllocationModal = ({
  show,
  onHide,
  tripId,
  onSubmit,
  errorMsgAllocation = {},
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [vehicleOption, setVehicleOption] = useState(null);
  const [driversOption, setDriversOption] = useState([]);
  const [vehicleError, setVehicleError] = useState("");
  const [driversError, setDriversError] = useState("");

  const handleCancel = () => {
    setVehicleOption(null);
    setDriversOption([]);
    setVehicleError("");
    setDriversError("");
    onHide();
  };

  const handleSubmit = () => {
    // Reset errors
    /* setVehicleError("");
    setDriversError("");

    let hasError = false;

    // Validate required fields
    if (!vehicleOption || !vehicleOption.value) {
      setVehicleError("The vehicle field is required.");
      hasError = true;
    }

    if (!driversOption || driversOption.length === 0) {
      setDriversError("The drivers field is required.");
      hasError = true;
    }

    if (hasError) {
      return;
    } */

    // payload
    const payload = {
      trip_id: tripId,
      vehicle_id: vehicleOption?.value ?? "",
      users: driversOption?.map((driver) => driver.value) ?? [],
    };

    onSubmit?.(payload);
  };

  // Check if form is valid
  const isFormValid =
    vehicleOption &&
    vehicleOption.value &&
    driversOption &&
    driversOption.length > 0;

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
        ? "#e0e0e0"
        : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const fetchDriver = async (inputValue, callback) => {
    try {
      const response = await getDriverAutoCompleteApi(
        driversOption.map((driver) => driver.value),
        inputValue
      );

      if (response.data.success === true) {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      }
    } catch (err) {
      callback([]);
    } finally {
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      centered
      backdrop="static"
      size="md"
    >
      <Modal.Header className="border-0" style={{ padding: "20px 24px" }}>
        <div
          className="mt-3 d-flex align-items-center gap-3"
          style={{ width: "100%" }}
        >
          <div style={{ cursor: "pointer" }} onClick={handleCancel}>
            <MoveLeft size={20} />
          </div>
          <div className="d-flex flex-column">
            <div className="fs-20 fw-700 textFontColor">Driver allocation</div>
            <div className="fs-12 fw-400 textGrey">
              Allocate driver to this trip
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body style={{ padding: "18px 24px" }}>
        <div className="mb-3">
          <div className="form-label fs-13 fw-600 text-start vehicle-label mb-2">
            Vehicle Number
          </div>
          <CommonDropdown
            apiUrl={`${apiUrl}vehicle/autosuggestion`}
            placeholder="Select"
            value={vehicleOption}
            onSelect={(value) => {
              setVehicleOption(value);
              if (value) {
                setVehicleError("");
              }
            }}
          />
          {errorMsgAllocation.vehicle_id && (
            <div
              className="text-danger fs-12 fw-400 mt-1"
              style={{ marginLeft: "2px" }}
            >
              {errorMsgAllocation.vehicle_id}
            </div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">
            Drivers
          </label>
          <AsyncSelect
            isMulti
            cacheOptions
            value={driversOption}
            loadOptions={fetchDriver}
            onChange={(selectedOptions) => {
              const removed = driversOption.filter(
                (oldItem) =>
                  !selectedOptions?.some(
                    (newItem) => newItem.value === oldItem.value
                  )
              );

              /* if (removed.length > 0) {
                setRemoveSupplierList((prev) => [...prev, ...removed]);
              } */

              setDriversOption(selectedOptions);
              if (selectedOptions && selectedOptions.length > 0) {
                setDriversError("");
              }
            }}
            defaultOptions
            placeholder="Search from address..."
            styles={multiselectCustomStyles}
            isClearable={false}
          />
          {errorMsgAllocation.users && (
            <div
              className="text-danger fs-12 fw-400 mt-1"
              style={{ marginLeft: "2px" }}
            >
              {errorMsgAllocation.users}
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "0" }}>
        <Button
          variant="outline-secondary"
          onClick={handleCancel}
          className="rounded-pill px-4"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          className="rounded-pill px-4"
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DriverAllocationModal;
